module.exports = __webpack_public_path__ + "img/settings.2e7e623e.svg";